"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _formik = require("formik");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _selectors = require("@otpusk/apisearch-toolbox/dist/services/selectors");
var R = _interopRequireWildcard(require("ramda"));
var _constants = require("../../../../constants");
var _withGetHotelsAction = _interopRequireDefault(require("../../hocs/withGetHotelsAction"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var DISALBED_SERVICES = ['byCountries', 'promo', 'icons', 'tabs', 'rootGroups'];
var withServicesControlProps = function withServicesControlProps(Component) {
  var WithServicesControlProps = function WithServicesControlProps(_ref) {
    var getHotels = _ref.getHotels,
      formik = _ref.formik;
    var values = formik.values,
      setFieldValue = formik.setFieldValue;
    var countryID = values[_fn.QUERY_PARAMS.COUNTRY],
      selectedServices = values[_fn.QUERY_PARAMS.SERVICES];
    var initialSelectedServicesHub = (0, _react.useRef)(selectedServices);
    var labels = (0, _reactRedux.useSelector)(_selectors.getLabels);
    var servicesByCountryID = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors.getServicesByCountryID)(state, {
        countryID: countryID
      });
    });
    var servicesForIcons = (0, _reactRedux.useSelector)(function (state) {
      return (0, _selectors.getServicesIconsForHotel)(state, {
        countryID: countryID
      });
    });
    var allServices = (0, _reactRedux.useSelector)(_selectors.getAllServices);
    var handleApply = (0, _react.useCallback)(function (nextServices) {
      return initialSelectedServicesHub.current = nextServices, setFieldValue(_fn.QUERY_PARAMS.SERVICES, nextServices), getHotels(nextServices);
    }, [getHotels, setFieldValue]);
    var handleReset = (0, _react.useCallback)(function () {
      return setFieldValue(_fn.QUERY_PARAMS.SERVICES, []), getHotels([]);
    }, [getHotels, setFieldValue]);
    var handleToggle = (0, _react.useCallback)(function (service) {
      var nextServices = R.includes(service, selectedServices) ? R.without([service], selectedServices) : R.append(service, selectedServices);
      setFieldValue(_fn.QUERY_PARAMS.SERVICES, nextServices);
      getHotels(nextServices);
    }, [getHotels, selectedServices, setFieldValue]);
    var favoritServices = (0, _react.useMemo)(function () {
      return R.map(function (service) {
        return {
          icon: _constants.FAVORIT_SERVICES_ICONS[service],
          label: labels[service],
          service: service
        };
      }, R.uniq([].concat(_toConsumableArray(servicesForIcons), _toConsumableArray(initialSelectedServicesHub.current), _toConsumableArray(selectedServices))));
    }, [initialSelectedServicesHub, labels, selectedServices, servicesForIcons]);
    var servicesListByCountryID = (0, _react.useMemo)(function () {
      return R.call(R.pipe(R.omit(DISALBED_SERVICES), R.toPairs, R.map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          group = _ref3[1];
        return group;
      }), R.filter(function (group) {
        return !R.isEmpty(group);
      }), R.flatten, R.map(function (service) {
        return {
          service: service,
          label: labels[service]
        };
      })), servicesByCountryID);
    }, [labels, servicesByCountryID]);
    var allServicesList = (0, _react.useMemo)(function () {
      return R.call(R.pipe(R.omit(DISALBED_SERVICES), R.toPairs, R.map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          groupKey = _ref5[0],
          group = _ref5[1];
        return {
          service: groupKey,
          label: labels[groupKey],
          group: R.map(function (service) {
            return {
              service: service,
              label: labels[service]
            };
          }, group)
        };
      }), R.filter(function (_ref6) {
        var label = _ref6.label,
          group = _ref6.group;
        return label && !R.isEmpty(group);
      })), allServices);
    }, [allServices, labels]);
    return /*#__PURE__*/_react.default.createElement(Component, {
      favoritServices: favoritServices,
      popularServices: selectedServices,
      selectedServices: selectedServices,
      services: allServicesList,
      servicesByCountryID: servicesListByCountryID,
      onApply: handleApply,
      onReset: handleReset,
      onToggle: handleToggle
    });
  };
  var enhancer = R.compose(_withGetHotelsAction.default, _formik.connect);
  return enhancer(WithServicesControlProps);
};
var _default = exports.default = withServicesControlProps;